import * as React from 'react';
import { useSelector } from 'react-redux';

import { isEmpty } from 'lodash/fp';

import { H4, SectionBody, SectionHeader } from '@portal/common/components';

import _ from '../../locale';
import { getConditionDetailNotes, getQueriedConditions } from '../../store/data-explorer/selectors';
import ConditionDetailNotesTable from './ConditionDetailNotesTable';

const ConditionDetailNotesSection = () => {
    const conditions = useSelector(getQueriedConditions);
    const conditionDetailNotes = useSelector(getConditionDetailNotes);

    if (isEmpty(conditions) || isEmpty(conditionDetailNotes)) {
        return null;
    }

    return (
        <SectionBody id="cdn">
            <SectionHeader>
                <H4>{_.get('custom_chart_scene_condition_detail_notes_title')}</H4>
            </SectionHeader>
            {conditionDetailNotes.map((i, idx) => (
                <ConditionDetailNotesTable key={idx} conditionDetailNotes={i} />
            ))}
        </SectionBody>
    );
};

export default ConditionDetailNotesSection;
